import { useState } from 'react';

interface CodeBlockProps {
  code: string;
  language?: string;
  title?: string;
}

export default function CodeBlock({ code, language = 'bash', title }: CodeBlockProps) {
  const [copied, setCopied] = useState(false);

  const copy = async () => {
    try {
      await navigator.clipboard.writeText(code);
      setCopied(true);
      setTimeout(() => setCopied(false), 1600);
    } catch {
      setCopied(false);
    }
  };

  return (
    <div className="bg-foreground-950 rounded-lg overflow-hidden">
      <div className="flex items-center justify-between gap-3 px-4 py-2.5 border-b border-white/10">
        <span className="text-xs text-white/50 font-mono truncate">{title ?? language}</span>
        <button
          type="button"
          onClick={copy}
          className="whitespace-nowrap inline-flex items-center gap-1.5 text-xs font-medium text-white/70 hover:text-white transition-colors cursor-pointer"
        >
          <i className={`${copied ? 'ri-check-line text-accent-400' : 'ri-file-copy-line'}`}></i>
          {copied ? 'Copied' : 'Copy'}
        </button>
      </div>
      <pre className="p-4 text-sm text-accent-200 font-mono overflow-x-auto leading-relaxed whitespace-pre">{code}</pre>
    </div>
  );
}